import type { FC } from 'react'
import { memo, useMemo } from 'react'
import styled from 'styled-components'

import { TicketBoardColumn } from './components/TicketBoardColumn'
import type { IndexedCard } from './filtering/cardIndex'
import { resolveBoardColumns } from './filtering/resolveBoardColumns'
import type { BoardConfig, PillCategories } from './types'

/**
 * Fills the dashboard body. A plain flex row rather than antd's Row, whose
 * gutter margins overflow the page sideways. Columns shrink to their minimum
 * before the board scrolls sideways within itself.
 */
const Columns = styled.div`
  display: flex;
  flex: 1;
  gap: 0.75rem;
  min-height: 0;
  overflow-x: auto;
`

const ColumnSlot = styled.div`
  flex: 1 1 0;
  min-width: 12rem;
`

interface TicketBoardViewProps {
  board: BoardConfig
  rows: IndexedCard[]
  categories: PillCategories
  onSelect: (cardId: string) => void
}

const RawTicketBoardView: FC<TicketBoardViewProps> = ({
  board,
  rows,
  categories,
  onSelect,
}) => {
  const columns = useMemo(() => resolveBoardColumns(board, rows), [board, rows])

  return (
    <Columns>
      {columns.map((column) => (
        <ColumnSlot key={column.id}>
          <TicketBoardColumn
            column={column}
            categories={categories}
            onSelect={onSelect}
          />
        </ColumnSlot>
      ))}
    </Columns>
  )
}

export const TicketBoardView = memo(RawTicketBoardView)
